import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';

const CustomReactSelect = ({
	allItems,
	title,
	onSetSelectedItem,
	type,
	loadOptions,
	handleInputChange,
	selectedValue,
	onTotalPercentage,
	isMulti = true,
	onCreateOption,
	isClearable = true,
	defaultMenuIsOpen = false,
	autoFocus = false,
	onRemoveValue,
	randerCreateLabelJSX = null
}) => {
	const onSelectItem = (selected, actionMeta) => {
		if (actionMeta.action === 'remove-value' && onRemoveValue) {
			onRemoveValue(actionMeta.removedValue);
			return;
		}
		if (onTotalPercentage) {
			onTotalPercentage(selected);
		}
		onSetSelectedItem(selected);
	};

	const styles = {
		control: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		}),
		menu: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		})
	};

	return (
		<div className="form-group no-shadow-react-select size36">
			{type === 'ASYNC' ? (
				<AsyncSelect
					styles={styles}
					defaultOptions
					isMulti
					value={selectedValue}
					// getOptionLabel={(e) => e.label}
					// getOptionValue={(e) => e.value}
					loadOptions={loadOptions}
					onInputChange={handleInputChange}
					onChange={onSelectItem}
					placeholder={title}
					isOptionDisabled={(option) => option.isDisable}
				/>
			) : type === 'CREATABLE' ? (
				<CreatableSelect
					styles={styles}
					value={selectedValue}
					isMulti
					onChange={onSelectItem}
					options={allItems}
					placeholder={title}
					isSearchable={true}
					isClearable={isClearable}
					closeMenuOnSelect={false}
					onCreateOption={onCreateOption}
					defaultMenuIsOpen={defaultMenuIsOpen}
					autoFocus={autoFocus}
					formatCreateLabel={randerCreateLabelJSX}
					isValidNewOption={(inputValue, _selectValue, selectOptions) => {
						const matchingOptions = selectOptions.filter((option) =>
							option.name.toLowerCase().includes(inputValue.toLowerCase())
						);
						const isTyping = inputValue.trim().length > 0;
						return matchingOptions.length === 0 && isTyping;
					}}
				/>
			) : (
				<Select
					value={selectedValue}
					styles={styles}
					options={allItems}
					isClearable
					isMulti={isMulti}
					onChange={onSelectItem}
					closeMenuOnSelect={false}
					placeholder={title}
					isSearchable={true}
				/>
			)}
		</div>
	);
};

export default CustomReactSelect;
